import { useEffect } from "react";

const listeners = {};

export const dispatchEvent = (event, payload) => {
    if (!listeners[event]) return;
    listeners[event].forEach((callback) => callback(payload));
};

export const useEvent = (event, callback) => {
    useEffect(() => {
        if (!listeners[event]) {
            listeners[event] = [];
        }
        listeners[event].push(callback);

        return () => {
            listeners[event] = listeners[event].filter((cb) => cb !== callback);
        };
    }, [event, callback]);
};
